import "core-js/modules/es.array.push.js";
// import { computed, ref } from "vue";
import { defineComponent, reactive, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "TopHeader",
  setup() {
    const activeIndex = ref("1");
    const {
      locale
    } = useI18n();
    const router = useRouter();
    const headerMenu = reactive(["home", "experience", "projects", "publications"]);
    const buttons = [{
      type: "primary",
      text: "EN"
    }, {
      type: "primary",
      text: "ZH"
    }];
    let currentLanguage = ref(locale.value);
    function setLanguage() {
      let lang = locale.value === "en" ? "zh" : "en";
      currentLanguage.value = lang;
      locale.value = lang;
    }
    function goHome() {
      router.push("/");
    }
    return {
      setLanguage,
      activeIndex,
      headerMenu,
      buttons,
      currentLanguage,
      goHome
    };
  }
});